export enum Schema {
    Preview = 'GBBPreview',
    Master = 'GBBMaster',
    MasterReview = 'GBBMasterReview',
    GBB = 'GBB'
}
